import IWpMenuItem from "../interfaces/IWpMenuItem"

export default function findLocalMenu(
  localParentId: number,
  menuItems: Array<IWpMenuItem>
): IWpMenuItem | null {
  for (const menuItem of menuItems) {
    if (
      menuItem?.databaseId === localParentId ||
      (menuItem?.connectedNode?.node?.databaseId &&
        menuItem.connectedNode.node.databaseId === localParentId)
    ) {
      // console.log(
      //   `PAGE found local menu for ${localParentId}`,
      //   menuItem.connectedNode.node.databaseId
      // )
      return menuItem
    }
    for (const child of menuItem.children || []) {
      if (
        child?.databaseId === localParentId ||
        (child?.connectedNode?.node?.databaseId &&
          child.connectedNode.node.databaseId === localParentId)
      ) {
        // console.log(
        //   `PAGE child found local menu for ${localParentId}`,
        //   child.connectedNode.node.databaseId
        // )
        return child
      }
      for (const grandchild of child.children || []) {
        if (
          grandchild?.databaseId === localParentId ||
          (grandchild?.connectedNode?.node?.databaseId &&
            grandchild.connectedNode.node.databaseId === localParentId)
        ) {
          // console.log(
          //   `PAGE grandchild found local menu for ${localParentId}`,
          //   grandchild.connectedNode.node.databaseId
          // )
          return grandchild
        }
        for (const greatGrandchild of grandchild.children || []) {
          if (
            greatGrandchild?.databaseId === localParentId ||
            (greatGrandchild?.connectedNode?.node?.databaseId &&
              greatGrandchild.connectedNode.node.databaseId === localParentId)
          ) {
            // console.log(
            //   `PAGE greatgrandchild found local menu for ${localParentId}`,
            //   greatGrandchild.connectedNode.node.databaseId
            // )
            return greatGrandchild
          }
          for (const greatGreatGrandchild of greatGrandchild.children || []) {
            if (
              greatGreatGrandchild?.databaseId === localParentId ||
              (greatGreatGrandchild?.connectedNode?.node?.databaseId &&
                greatGreatGrandchild.connectedNode.node.databaseId ===
                  localParentId)
            ) {
              // console.log(
              //   `PAGE greatgrandchild found local menu for ${localParentId}`,
              //   greatGreatGrandchild.connectedNode.node.databaseId
              // )
              return greatGreatGrandchild
            }
          }
        }
      }
    }
  }
  return null
}
